import styled from "styled-components";

const DomainInputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export { DomainInputContainer };
